module.exports = __webpack_public_path__ + "img/q.3fd34c17.jpg";